// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"ai-book-open"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M12 6.5V22.0002C12 20.3434 9.31371 19.0002 6 19.0002C4.46329 19.0002 3.06151 19.2891 2 19.7641V4.26389C2 4.26389 3 3.5 6 3.5C9.31371 3.5 12 4.84315 12 6.5Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M19.25 3L19.7697 4.23028L21 4.75L19.7697 5.26972L19.25 6.5L18.7303 5.26972L17.5 4.75L18.7303 4.23028L19.25 3Z","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M12 22.0002V6.50002M12 22.0002C12 20.3434 14.6863 19.0002 18 19.0002C19.5367 19.0002 20.9385 19.2891 22 19.7641V9.99982M12 22.0002C12 20.3434 9.31371 19.0002 6 19.0002C4.46329 19.0002 3.06151 19.2891 2 19.7641V4.26389C2 4.26389 3 3.5 6 3.5C9.31371 3.5 12 4.84317 12 6.50002M12 6.50002C12 5.88665 12.3682 5.31628 13 4.84113","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-ai-book-open')
export default class AiBookOpenIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'ai-book-open',
    }
  }
}
